const slugToCategoryMap: Record<string, string> = {
  "product-sourcing": "Product Sourcing",
  "wholesale": "Wholesale",
  "inventory": "Inventory",
  "logistics": "Logistics",
  "supply-chain": "Supply Chain",
};

export const categoryToSlug = (category: string): string =>
  category.toLowerCase().replace(/\s+/g, "-");

export const slugToCategory = (slug: string): string | null =>
  slugToCategoryMap[slug] ?? null;

export const validCategorySlugs = Object.keys(slugToCategoryMap);
